import React, { useState } from 'react';
import { useTranslation } from '@common/hooks/translation';

import './style.scss';
import NumericInput from '@common/components/numericInput';
import { PredifinedAmounts } from './predifinedAmounts';
import ToastWrapper from '@common/helpers/toastWrapper';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { getAuthData } from '@common/helpers/auth';
import {
  MPESA_PLAYER_STORAGE_KEY,
  PAYMENT_STATUS_URLS,
  PENDING_PAYMENT_STORAGE_KEY,
} from '../../constants/paymentRedirect';
import { store } from '../../../index/terminalApp';

export const MpesaDeposit = ({ openPopup, closePopup }) => {
  const t = useTranslation();
  const [amount, setAmount] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { currency } = getAuthData()

  const onDeposit = async () => {
    try {
      setIsLoading(true);

      // Callback URLs are derived from the current skin origin in
      // PAYMENT_STATUS_URLS — passed to KesPay so the provider knows
      // where to redirect once the transaction is finalised.
      const req = {
        amount: +amount,
        service: 20417,
        payer: {
          forProduct: 'sport',
          isAmountHidden: false,
          status_urls: PAYMENT_STATUS_URLS,
        },
      }
      console.log(req, 'reqqq')
      const res = await swarmRequest(req, 'deposit_v2');

      if (res.status === 'error')
        return ToastWrapper('error', res.message || 'Something went wrong while doing a deposit')

      // Same defensive lookup as withdraw — pull the action URL from
      // any of the common response shapes, toast + bail if none of them
      // resolves so we don't redirect to about:blank.
      const payment = res?.data || res || {};
      const redirectUrl = payment.action || payment.url || payment.redirectUrl || payment.action_url;
      if (!redirectUrl) {
        console.warn('[mpesaDeposit] no action URL in response', res);
        return ToastWrapper('error', 'Deposit could not be initiated. Please try again.');
      }

      // Stash context for `PaymentCallbackBridge` to consume after KesPay
      // redirects back to one of `/payment-*`. sessionStorage survives the
      // full-page navigation; Redux does not, so we also persist the
      // M-Pesa player info and re-apply it on return — otherwise the user
      // comes back "logged out" of their M-Pesa session.
      try {
        sessionStorage.setItem(
          PENDING_PAYMENT_STORAGE_KEY,
          JSON.stringify({ type: 'deposit', initiatedAt: Date.now() }),
        );
        const playerInfo = store.getState()?.terminal?.playerInfo;
        if (playerInfo && playerInfo.PersonalId) {
          sessionStorage.setItem(MPESA_PLAYER_STORAGE_KEY, JSON.stringify(playerInfo));
        }
      } catch (_) {
        // Quota / disabled storage — proceed anyway; toast will still
        // appear, but the user might lose their M-Pesa session.
      }

      closePopup();
      // Same-tab redirect to KesPay. `replace` so the deposit URL doesn't
      // leave an extra entry in the back-button history. KesPay redirects
      // back to `<origin>/?status=...&reference=...` afterwards, and the
      // `PaymentStatusListener` mounted inside Layout picks the query
      // params up and fires the matching toast.
      window.location.replace(redirectUrl);
    } catch (ex) {
      ToastWrapper('error', 'Something went wrong while depositing')
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="popup-content popup-small mpesa-deposit-popup">
      <i onClick={closePopup} className="global-icon icon-Close close-popup" />
      <h3 className="popup-title">{t('M-Pesa Deposit')}</h3>
      <p className='popup-subtitle'>{t('Please input the deposit amount')}</p>
      <div className="popup-main-content">
        <i className='global-icon icon-mpesa-deposit' />
        <div className='input-wrapper'>
          {
            amount && <p className="popup-txt">{t('Deposit amount')}</p>
          }
          <div className='input-row'>
            <NumericInput
              value={amount}
              placeholder={t('Deposit amount')}
              onChange={setAmount}
              class="popup-inp"
              disableSearchIcon
            />
            <div className='input-right-content'>
              <span className='currency'>{currency}</span>
            </div>
          </div>
        </div>
        <PredifinedAmounts onSelect={setAmount} value={amount} />
      </div>
      <div className="popup-actions">
        <button
          className="popup-confirm-button"
          disabled={!+amount || isLoading}
          onClick={onDeposit}
        >
          {
            t(isLoading ? 'Processing...' : 'Deposit')
          }
        </button>
      </div>
    </div>
  )
}